var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPajamas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6901_7857)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6901_7857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 11.9998L8.90978 17.7898C8.72241 17.976 8.46896 18.0806 8.20478 18.0806C7.94059 18.0806 7.68714 17.976 7.49978 17.7898C7.31353 17.6024 7.20898 17.349 7.20898 17.0848C7.20898 16.8206 7.31353 16.5671 7.49978 16.3798L11.8698 11.9998L7.49978 7.61977C7.31353 7.43241 7.20898 7.17896 7.20898 6.91477C7.20898 6.65059 7.31353 6.39714 7.49978 6.20977C7.68714 6.02352 7.94059 5.91898 8.20478 5.91898C8.46896 5.91898 8.72241 6.02352 8.90978 6.20977L14.6998 11.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49982 12.0001L2.70982 17.7901C2.61685 17.8839 2.50625 17.9583 2.38439 18.009C2.26253 18.0598 2.13183 18.0859 1.99982 18.0859C1.8678 18.0859 1.7371 18.0598 1.61524 18.009C1.49338 17.9583 1.38278 17.8839 1.28982 17.7901C1.10356 17.6028 0.999023 17.3493 0.999023 17.0851C0.999023 16.821 1.10356 16.5675 1.28982 16.3801L5.66982 12.0001L1.28982 7.62014C1.10356 7.43278 0.999023 7.17933 0.999023 6.91514C0.999023 6.65095 1.10356 6.3975 1.28982 6.21014C1.38278 6.11641 1.49338 6.04202 1.61524 5.99125C1.7371 5.94048 1.8678 5.91434 1.99982 5.91434C2.13183 5.91434 2.26253 5.94048 2.38439 5.99125C2.50625 6.04202 2.61685 6.11641 2.70982 6.21014L8.49982 12.0001Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6901_7857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 15,
    fill: "white",
    transform: "translate(15) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6901_7857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(-6 30) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPajamas);
export default __webpack_public_path__ + "static/media/ic_pajamas.451f4bebfbd48d1ed9c8e52b65cdd8f6.svg";
export { ForwardRef as ReactComponent };